import { deleteUsergroupActions } from '../../constants';

export const deleteUserGroup = ({ items }) => ({
  type: deleteUsergroupActions.DELETE_USERGROUP,
  items,
});

export const deleteUserGroupError = (items) => ({
  type: deleteUsergroupActions.DELETE_USERGROUP_ERROR,
  items,
});

export const deleteUserGroupSuccess = (items) => ({
  type: deleteUsergroupActions.DELETE_USERGROUP_SUCCESS,
  items,
});

export const showDeleteUserGroupDialog = (userGroup) => ({
  type: deleteUsergroupActions.SHOW_DELETE_USERGROUP_DIALOG,
  userGroup,
});

export const showDeleteUserGroupsDialog = (category) => ({
  type: deleteUsergroupActions.SHOW_DELETE_USERGROUPS_DIALOG,
  category,
});

export const hideDeleteUserGroupDialog = () => ({
  type: deleteUsergroupActions.HIDE_DELETE_USERGROUP_DIALOG,
});
